import React, { useCallback } from "react";

import { FileDownloadOutlined as DownloadTasks } from "@mui/icons-material";
import { generateCSV } from "../../../../../utils";
import { CustomButton } from "../../../../../components/Button/Button";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { useMissingStatusReport } from "../../hooks/useMissingStatusReport";

export const DownloadMissingStatus = React.memo(() => {
  const isMobile = useResponsive("down", "md");
  const { csvRows } = useMissingStatusReport();

  const generateCSVFile = useCallback(() => {
    generateCSV(csvRows, "missing-status");
  }, [csvRows]);

  return (
    <>
      <CustomButton
        onClick={generateCSVFile}
        className="theme-bg-color capitalize ml-3 download-missing-status"
        variant="contained"
        color={"warning"}
        startIcon={<DownloadTasks />}
      >
        {!isMobile ? "Download CSV" : ""}
      </CustomButton>
    </>
  );
});
